import { render, staticRenderFns } from "./postGoogle.vue?vue&type=template&id=6763101e&"
import script from "./postGoogle.vue?vue&type=script&lang=js&"
export * from "./postGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports